import React, { useState, lazy } from 'react';
export function Reason5() {
  const [annualSpend, setAnnualSpend] = useState(13897);
  const medications = [{
    name: 'Sumatriptan prescriptions',
    cost: 2847
  }, {
    name: 'Quarterly Botox',
    cost: 4200
  }, {
    name: 'Massage therapy',
    cost: 3600
  }, {
    name: 'Acupuncture attempts',
    cost: 2400
  }, {
    name: 'That useless neurologist',
    cost: 850
  }];
  const totalCost = medications.reduce((sum, med) => sum + med.cost, 0);
  const savings = annualSpend - 179.99;
  const breakEvenDays = Math.ceil(179.99 / (annualSpend / 365));
  const features = [{
    name: 'Heat therapy',
    description: '(adjustable, not just on/off)',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-456">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-457" />
        </svg>
  }, {
    name: 'Air compression massage',
    description: '(temple, eye, and cheekbone regions)',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-458">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" data-id="element-459" />
        </svg>
  }, {
    name: 'Acupressure mapping',
    description: '(targeting those crucial nerve points)',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-460">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-461" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-462" />
        </svg>
  }, {
    name: 'Optional vibration',
    description: '(for those who tolerate it)',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-463">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" data-id="element-464" />
        </svg>
  }, {
    name: 'Cooling mode',
    description: '(for inflammation reduction)',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-465">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" data-id="element-466" />
        </svg>
  }, {
    name: '15-minute automatic cycles',
    description: '(perfect for habit formation)',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-467">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-468" />
        </svg>
  }];
  return <div className="py-12 border-t border-[#F1F5F9]" data-id="element-469">
      <div className="flex flex-col md:flex-row md:gap-8" data-id="element-470">
        <div className="md:w-2/3" data-id="element-471">
          <div className="flex items-center mb-4" data-id="element-472">
            <div className="bg-[#0EA5B7] text-white font-bold rounded-full w-10 h-10 flex items-center justify-center mr-4" data-id="element-473">
              5
            </div>
            <h2 className="text-2xl font-bold text-[#0F172A]" data-id="element-474">Reason #5:</h2>
          </div>
          <h3 className="text-xl font-semibold text-[#0F172A] mb-6" data-id="element-475">
            The One-Time Investment That Replaces Your Entire Medicine Cabinet
            (And Why Early Adopters Are Buying Multiple Units)
          </h3>
          <div className="mb-8" data-id="element-476">
            <picture data-id="element-477">
              <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/iXSzKZayH2FoXUK6yTwvPS/ChatGPT_Image_Sep_20%2C_2025%2C_06_52_54_PM.webp" type="image/webp" data-id="element-478" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iXSzKZayH2FoXUK6yTwvPS/ChatGPT_Image_Sep_20%2C_2025%2C_06_52_54_PM.webp" alt="iRelief Oculis-3 device compared to traditional migraine treatments cost comparison" className="w-full rounded-lg shadow-md" width="800" height="450" loading="lazy" data-id="element-479" />
            </picture>
          </div>
          <div className="prose prose-slate max-w-none" data-id="element-480">
            <p data-id="element-481">$119.99.</p>
            <p data-id="element-482">That's it. One time.</p>
            <p data-id="element-483">Compare that to what I spent last year alone:</p>
            <div className="bg-white rounded-lg p-4 my-4 shadow-sm" data-id="element-484">
              <ul className="space-y-2" data-id="element-485">
                <li data-id="element-486">Sumatriptan prescriptions: $2,847</li>
                <li data-id="element-487">Quarterly Botox: $4,200</li>
                <li data-id="element-488">Massage therapy: $3,600</li>
                <li data-id="element-489">Acupuncture attempts: $2,400</li>
                <li data-id="element-490">That useless neurologist: $850</li>
                <li className="font-bold border-t border-gray-200 pt-2 mt-2" data-id="element-491">
                  Total: $13,897. For one year. Of treatments that barely
                  worked.
                </li>
              </ul>
            </div>
            <p data-id="element-492">The iRelief Oculis-3? Paid for itself in 5 days.</p>
            <p data-id="element-493">
              But here's what nobody talks about — the hidden costs of our
              "solutions":
            </p>
            <p data-id="element-494">
              <strong data-id="element-495">Ice packs?</strong> Melt in 20 minutes. You're constantly
              refreezing, reapplying, dripping condensation on your pillow. One
              sufferer noted:{' '}
              <em data-id="element-496">
                "I sit alone in the bedroom, all lights off, no sound, no
                smell."
              </em>{' '}
              You become a prisoner.
            </p>
            <p data-id="element-497">
              <strong data-id="element-498">Professional massage?</strong> Amazing when you can get
              it. But try booking an appointment at 2 AM when a migraine
              strikes. Or explaining to your boss why you need to leave for a
              90-minute appointment. Again.
            </p>
            <p data-id="element-499">
              <strong data-id="element-500">The "latest" devices?</strong> I tried them all. The
              Cefaly ($400) felt like being tasered. The cooling caps ($200)
              gave me ice cream headaches. The TENS units ($300) did nothing.
            </p>
            <p data-id="element-501">
              The iRelief Oculis-3 is different because it's not trying to be
              one thing. It's engineered to be everything, simultaneously:
            </p>
            <ul className="list-disc pl-6 space-y-2 my-4" data-id="element-502">
              <li data-id="element-503">Heat therapy (adjustable, not just on/off)</li>
              <li data-id="element-504">
                Air compression massage (temple, eye, and cheekbone regions)
              </li>
              <li data-id="element-505">
                Acupressure mapping (targeting those crucial nerve points)
              </li>
              <li data-id="element-506">Optional vibration (for those who tolerate it)</li>
              <li data-id="element-507">Cooling mode (for inflammation reduction)</li>
              <li data-id="element-508">15-minute automatic cycles (perfect for habit formation)</li>
            </ul>
            <p data-id="element-509">
              Silent enough for bedroom use. Portable enough for travel. USB-C
              rechargeable. No appointments. No prescriptions. No geographic
              limitations.
            </p>
            <p data-id="element-510">
              One user bought three:{' '}
              <em data-id="element-511">
                "Home, office, and car. I refuse to be caught without it."
              </em>
            </p>
            <p data-id="element-512">That's not addiction. That's intelligence.</p>
            <p data-id="element-513">
              Because when you finally find something that gives you your life
              back, you protect it.
            </p>
            <div className="mt-8" data-id="element-514">
              <picture data-id="element-515">
                <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/eyCUGP7Ws9quE2T26gCcw3/ChatGPT_Image_Sep_20%2C_2025%2C_07_51_28_PM.webp" type="image/webp" data-id="element-516" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eyCUGP7Ws9quE2T26gCcw3/ChatGPT_Image_Sep_20%2C_2025%2C_07_51_28_PM.webp" alt="Person suffering from migraine in bed with iRelief Oculis-3 device features displayed" className="w-full rounded-lg shadow-md" width="800" height="450" loading="lazy" data-id="element-517" />
              </picture>
            </div>
          </div>
        </div>
        <div className="md:w-1/3 mt-8 md:mt-0" data-id="element-518">
          <div className="bg-white rounded-lg shadow-sm border border-[#F1F5F9] p-4 mb-6" data-id="element-519">
            <h4 className="font-medium text-[#0F172A] mb-4" data-id="element-520">ROI Calculator</h4>
            <div className="mb-4" data-id="element-521">
              <label className="block text-sm font-medium text-[#334155] mb-1" data-id="element-522">
                Your annual migraine expenses:
              </label>
              <div className="relative" data-id="element-523">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#334155]" data-id="element-524">
                  $
                </span>
                <input type="number" value={annualSpend} onChange={e => {
                const value = parseFloat(e.target.value) || 0;
                setAnnualSpend(value);
              }} className="w-full pl-8 pr-3 py-2 border border-[#F1F5F9] rounded-md" min="0" step="0.01" data-id="element-525" />
              </div>
            </div>
            <div className="bg-[#F1F5F9] p-4 rounded-lg mb-4" data-id="element-526">
              <div className="flex justify-between mb-2" data-id="element-527">
                <span className="text-sm text-[#334155]" data-id="element-528">
                  Your annual cost:
                </span>
                <span className="text-sm font-medium text-[#0F172A]" data-id="element-529">
                  $
                  {annualSpend.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                </span>
              </div>
              <div className="flex justify-between mb-2" data-id="element-530">
                <span className="text-sm text-[#334155]" data-id="element-531">
                  iRelief Oculis-3:
                </span>
                <span className="text-sm font-medium text-[#0F172A]" data-id="element-532">
                  $119.99
                </span>
              </div>
              <div className="flex justify-between pt-2 border-t border-white" data-id="element-533">
                <span className="text-sm font-medium text-[#334155]" data-id="element-534">
                  Annual savings:
                </span>
                <span className="text-sm font-bold text-[#0EA5B7]" data-id="element-535">
                  $
                  {Math.max(0, annualSpend - 119.99).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                </span>
              </div>
            </div>
            <div className="text-center p-3 bg-[#0EA5B7] text-white rounded-md" data-id="element-536">
              {annualSpend > 119.99 ? <>
                  <div className="text-lg font-bold" data-id="element-537">
                    Pays for itself in{' '}
                    {Math.max(1, Math.ceil(119.99 / ((annualSpend - 119.99) / 365)))}{' '}
                    days
                  </div>
                  <div className="text-xs" data-id="element-538">Based on your current spending</div>
                </> : <div className="text-lg font-medium" data-id="element-539">
                  Enter annual expenses above $119.99 to see your savings
                </div>}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-[#F1F5F9] p-4" data-id="element-540">
            <h4 className="font-medium text-[#0F172A] mb-4" data-id="element-541">
              All-in-One Features
            </h4>
            <div className="grid grid-cols-2 gap-4" data-id="element-542">
              {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center p-3 bg-[#F1F5F9] rounded-lg" data-id="element-543">
                  <div className="text-[#0EA5B7] mb-2" data-id="element-544">{feature.icon}</div>
                  <div className="text-sm font-medium text-[#0F172A]" data-id="element-545">
                    {feature.name}
                  </div>
                  <div className="text-xs text-[#334155] mt-1" data-id="element-546">
                    {feature.description}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}